import { createContext as e, useCallback as t, useContext as n, useEffect as r, useRef as i, useState as a } from "react";
import { styled as o } from "styled-components";
import { jsx as s } from "react/jsx-runtime";
//#region src/components/Table/Filters.tsx
var c = e(null), l = o.div`
    position: sticky;
    top: 0;
    z-index: 10;
    background-color: ${({ theme: e }) => e.colors.card};
    padding: ${({ theme: e }) => e.spacing(4, 0)};
    border-bottom: 1px solid ${({ theme: e }) => e.colors.border};
    margin-bottom: ${({ theme: e }) => e.spacing(4)};
`, u = ({ children: e, className: n, debounceMs: o = 300 }) => {
	let [u, d] = a(new URLSearchParams()), [f, p] = a({}), m = i({});
	r(() => {
		let e = {};
		for (let [t, n] of u.entries()) {
			let r = u.getAll(t);
			r.length > 1 ? e[t] = r : e[t] = n;
		}
		p(e);
	}, [u]);
	let h = t((e) => f[e] ?? "", [f]), g = t((e, t) => {
		p((n) => {
			let r = { ...n };
			return t === "" || t === !1 || t === null || Array.isArray(t) && t.length === 0 ? delete r[e] : r[e] = String(t), r;
		}), m.current[e] && clearTimeout(m.current[e]), m.current[e] = setTimeout(() => {
			d((n) => {
				let r = new URLSearchParams(n);
				return r.delete(e), Array.isArray(t) ? t.length > 0 && t.forEach((t) => r.append(e, String(t))) : t !== "" && t !== !1 && t != null && r.set(e, String(t)), r;
			});
		}, o);
	}, [d, o]);
	return /* @__PURE__ */ s(c.Provider, {
		value: {
			getValue: h,
			setValue: g
		},
		children: /* @__PURE__ */ s(l, {
			className: n,
			children: e
		})
	});
}, d = () => {
	let e = n(c);
	if (!e) throw Error("Filter components must be used within a FilterProvider");
	return e;
}, f = (e, t) => {
	let { getValue: n, setValue: r } = d(), i = n(e), a = i;
	return t === "boolean" ? a = i === "true" ? !0 : i === "false" ? !1 : void 0 : t === "number" && (a = i !== "" && i !== void 0 ? Number(i) : ""), {
		name: e,
		value: a,
		...t === "boolean" ? { checked: a } : {},
		onChange: (n) => {
			n && n.target && n.target.value !== void 0 ? t === "boolean" && n.target.checked !== void 0 ? r(e, n.target.checked) : r(e, n.target.value) : r(e, n);
		}
	};
};
//#endregion
export { u as FilterProvider, f as useFilterBinding, d as useFilterContext };
